export const dictionaryContext = {
  dictionary: '/dictionary-service/api/external/dictionary/value',
  dictionaryItem: '/dictionary-service/api/external/dictionary/value/{id}',
  regions: '/dictionary-service/api/external/dictionary/suggestions',
};
